import Slider from "react-slick";

const NewestCarFleet = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true, // Enables auto-sliding
    autoplaySpeed: 10000, // Set to 10 seconds (10000 ms)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const cars = [
    { 
      image: '/tempo.jpeg', 
      name: 'Force Traveller', 
      description: 'Perfect for group travels with spacious seating and robust performance.' 
    },
    { 
      image: '/innova.png', 
      name: 'Toyota Innova', 
      description: 'Reliable and comfortable multi-purpose vehicle ideal for families and long journeys.' 
    },
    { 
      image: '/dzire.jpeg', 
      name: 'Maruti Suzuki Dzire', 
      description: 'Compact sedan offering great mileage and comfort for city rides and commutes.' 
    },
    { 
      image: '/rumion.png', 
      name: 'Toyota Rumion', 
      description: 'Versatile MPV with ample space and a smooth driving experience.' 
    },
    { 
      image: '/ertiga.jpeg', 
      name: 'Maruti Suzuki Ertiga', 
      description: 'Efficient family car with advanced safety features and a spacious interior.' 
    },
  ];
  
  return (
    <section id="fleet" className="bg-white py-12">
      <div className="container mx-auto">
        <h2 className="text-4xl text-center underline font-bold text-red-500 mb-10">Our Newest Car Fleet</h2>
        <Slider {...settings}>
          {cars.map((car, index) => (
            <div key={index} className="p-4">
              <div className="bg-white rounded-lg shadow-lg p-4 text-center">
                <img
                  src={car.image}
                  alt={car.name}
                  className="w-full h-48 object-cover mb-4 rounded-lg"
                />
                <h3 className="text-xl font-semibold text-black mb-2">{car.name}</h3>
                <p className="text-gray-700">{car.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default NewestCarFleet;
